import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import { rootReducer } from "./reducers";
import { persistReducer, persistStore } from "redux-persist";
import sessionStorage from "redux-persist/lib/storage/session";
// import storage from "redux-persist/lib/storage";

const initalState = {};
const persistConfig = {
  key: "app-store",
  storage: sessionStorage,
  blacklist: ["SearchFilterReducer"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middleware = [thunk];
const store = createStore(
  persistedReducer,
  initalState,
  composeWithDevTools(applyMiddleware(...middleware))
);

let persistor = persistStore(store);
export { store, persistor };
